import { ofType } from "redux-observable";
import { of } from "rxjs";
import { concat } from "rxjs";
import normalize from "json-api-normalizer";
import { mergeMap } from "rxjs/operators";
import { push } from "react-router-redux";
import { notification } from "antd";
import { pendingCondition, begin, end } from "react-redux-spinner";
import { parseError } from "./lib";

import ConditionService from "../services/conditionService";

import {
  loadConditionsSuccess,
  loadConditionsFailure,
  LOAD_CONDITIONS_REQUEST_ACTION,
  SAVE_CONDITION_REQUEST_ACTION,
  saveConditionFailure,
  saveConditionSuccess,
  DELETE_CONDITION_REQUEST_ACTION,
  deleteConditionFailure,
  deleteConditionSuccess,
  SAVE_CONDITION_SUCCESS_ACTION,
  saveConditionRequest,
  SAVE_CONDITION_FAILURE_ACTION
} from "../ducks/data";
import { setActiveDialog } from "../ducks/app";

import {
  saveConditionFormSuccess,
  saveConditionFormFailure,
  SAVE_CONDITION_FORM_REQUEST_ACTION
} from "../ducks/condition";

export const loadConditionsEpic = (action$, state$) =>
  action$.pipe(
    ofType(LOAD_CONDITIONS_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let conditionService = new ConditionService();
      return conditionService
        .findAll(action.payload)
        .then(response => {
          return loadConditionsSuccess(normalize(response.data));
        })
        .catch(error => {
          return loadConditionsFailure(parseError(error));
        });
    })
  );

export const saveConditionFormRequestEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_CONDITION_FORM_REQUEST_ACTION.getType()),
    mergeMap(action => {
      return of(saveConditionRequest(action.payload));
    })
  );

export const saveConditionFormSuccessEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_CONDITION_SUCCESS_ACTION.getType()),
    mergeMap(action => {
      return concat(
        of(saveConditionFormSuccess(action.payload.user)),
        of(setActiveDialog())
      );
    })
  );

export const saveConditionFormFailureEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_CONDITION_FAILURE_ACTION.getType()),
    mergeMap(action => {
      // TODO: check result for validation failure or communication failure based on status
      return of(saveConditionFormFailure(action.payload));
    })
  );

export const saveConditionEpic = (action$, state$) =>
  action$.pipe(
    ofType(SAVE_CONDITION_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new ConditionService();
      return concat(
        service
          .save(action.payload)
          .then(response => {
            return saveConditionSuccess(normalize(response.data));
          })
          .catch(error => {
            return saveConditionFailure(parseError(error));
          })
      );
    })
  );

export const deleteConditionEpic = (action$, state$) =>
  action$.pipe(
    ofType(DELETE_CONDITION_REQUEST_ACTION.getType()),
    mergeMap(action => {
      let service = new ConditionService();
      return concat(
        service
          .archive(action.payload)
          .then(response => {
            return deleteConditionSuccess(action.payload);
          })
          .catch(error => {
            return deleteConditionFailure(parseError(error));
          }),
        of(setActiveDialog())
      );
    })
  );



// WEBPACK FOOTER //
// ./src/epics/conditions.js